<article class="lum-page lum-page__card lum-c-location">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">
      <a routerLink="/locations">Locations</a> /
      <ng-container *ngIf="location?.location_name; else headingWhenLoading">
        {{ location?.location_name }}
      </ng-container>
      <ng-template #headingWhenLoading>
        <mat-spinner class="d-inline-block" diameter="14"></mat-spinner>
      </ng-template>
    </h2>
    <div class="lum-page-header__actions">
      <button
        *ngIf="ftLocationBins"
        class="lum-button lum-button--secondary"
        (click)="locationAdjustmentEntry()"
      >
        <i class="fas fa-plus"></i>
        Add Adjustment Entry
      </button>
    </div>
  </header>

  <div class="lum-page-content">
    <ng-container *ngIf="!loading; else contentWhenLoading">
      <!--
        @TODO: Replace tabs with a link to /logs and breadcrumb back to the
        details [calvin]
      -->
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
        <a
          mat-tab-link
          [routerLink]="l.link"
          *ngFor="let l of navLinks"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          >{{ l.name }}</a
        >
      </nav>
      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </ng-container>
    <ng-template #contentWhenLoading>
      <div class="align-center">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </ng-template>
  </div>
</article>
